import React, { useState } from "react";
import axios from "axios"; // Import axios
import {
  Container,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import TitleIcon from "@mui/icons-material/Title";
import DescriptionIcon from "@mui/icons-material/Description";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import API_BASE_URL from "../../src/config";

const NewsLetter = () => {
  // State for form fields
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact_number: "",
    location: "",
    description: "",
  });

  // State for snackbar feedback and loading
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [loading, setLoading] = useState(false);

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if all required fields are filled
    if (
      !formData.name ||
      !formData.email ||
      !formData.contact_number ||
      !formData.location ||
      !formData.description
    ) {
      setSnackbarMessage("All fields are required.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setLoading(true);

    try {
      // const response = await axios.post(`${API_BASE_URL}/newsletter`, formData);
      const response = await axios.post(
        `${API_BASE_URL}/newsletter`,
        // `${API_BASE_URL}/newsletter`,
        formData
      );

      if (response.status === 201) {
        setSnackbarMessage("Successfully enrolled for NewsLetter !!!!");
        setSnackbarSeverity("success");
        setFormData({
          name: "",
          email: "",
          contact_number: "",
          location: "",
          description: "",
        });
      } else {
        setSnackbarMessage("An error occurred. Please try again.");
        setSnackbarSeverity("error");
      }
    } catch (error) {
      setSnackbarMessage("An error occurred. Please try again.");
      setSnackbarSeverity("error");
    }

    setLoading(false);
    setSnackbarOpen(true);
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5,mb:4 }}>
      <Card sx={{ p: 4, boxShadow: 4, borderRadius: 2 }}>
        <CardContent>
          <Typography
            variant="h5"
            color="black"
            fontWeight="bold"
            textAlign="center"
            mb={3}
          >
            Join for Updates & Notifications and more..
          </Typography>

          <form onSubmit={handleSubmit}>
            {/* Name */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <TitleIcon sx={{ flexShrink: 0, color: "primary.main" }} />
              <TextField
                fullWidth
                label="Name"
                variant="outlined"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Box>

            {/* Email */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <EmailIcon sx={{ flexShrink: 0, color: "primary.main" }} />
              <TextField
                fullWidth
                label="Email"
                variant="outlined"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Box>

            {/* Phone Number */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <PhoneIcon sx={{ flexShrink: 0, color: "primary.main" }} />
              <TextField
                fullWidth
                label="Phone Number"
                variant="outlined"
                name="contact_number"
                value={formData.contact_number}
                onChange={handleChange}
                required
              />
            </Box>

            {/* Location */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <LocationOnIcon sx={{ flexShrink: 0, color: "primary.main" }} />
              <TextField
                fullWidth
                label="Location"
                variant="outlined"
                name="location"
                value={formData.location}
                onChange={handleChange}
                required
              />
            </Box>

            {/* Description */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <DescriptionIcon sx={{ flexShrink: 0, color: "primary.main" }} />
              <TextField
                fullWidth
                label="Description"
                variant="outlined"
                name="description"
                value={formData.description}
                onChange={handleChange}
                multiline
                rows={3}
                required
              />
            </Box>

            {/* Submit Button */}
            <Button
              variant="contained"
              color="success"
              fullWidth
              sx={{ mt: 3, py: 1 }}
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          </form>
        </CardContent>
      </Card>

      {/* Snackbar for feedback */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default NewsLetter;
